import { getRuntimeInfo } from "./runtime-info";
import type { RuntimeInfo, UpdateCheckResult } from "./types";

export async function checkAndDownloadUpdate(): Promise<UpdateCheckResult> {
  return "disabled";
}

export type AppUpdates = {
  info: RuntimeInfo;
  isUpdatePending: boolean;
  isBusy: boolean;
  checkAndDownload: () => Promise<UpdateCheckResult>;
  applyUpdate: () => Promise<void>;
};

const noop = async () => {};

/** The web build is always the deployed bundle, so there is nothing to update. */
export function useAppUpdates(): AppUpdates {
  return {
    info: getRuntimeInfo(),
    isUpdatePending: false,
    isBusy: false,
    checkAndDownload: checkAndDownloadUpdate,
    applyUpdate: noop,
  };
}
